module.exports = __webpack_public_path__ + "img/icons_8.7ddc4be2.svg";